// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uY5H","clinicsSelect":"styles_clinicsSelect__2uBsq"};